import { render, staticRenderFns } from "./BtnStyle.vue?vue&type=template&id=1f99e312"
import script from "./BtnStyle.vue?vue&type=script&lang=js"
export * from "./BtnStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports